<div class="cart-item">
  <div class="row pb-2 pt-2 align-items-center">
    <button class="btn btn-light checkout-cart-step-delete-button" (click)="removeRow(data)">
      <i class="fas fa-times"></i>
    </button>
    <div class="col-1 col-md-1 d-flex align-items-center pb-1">
      <img
        class="img-fluid"
        src="https://cdn1.gung.io/fit-in/150x150/filters:fill(white):background_color(white):format(jpeg)/{{
          data.product.extra.images[0].s3Uri
        }}"
        alt=""
      />
    </div>
    <div class="col-10 col-md-2 text-truncate">
      {{ data.cartRow.productId }} - {{ data.product.name }}
      <div *ngIf="productAddons">
        <div class="pb-1 text-truncate small" *ngFor="let addon of productAddons.addons; trackBy: trackByAddon">
          <i class="fas fa-plus checkout-addon-icon"></i>&nbsp;{{ addon.product.id }} - {{ addon.product.name }}
        </div>
      </div>
    </div>

    <div class="col-6 col-md-2">
      <div class="row pt-1">
        <div class="col-4 d-flex d-md-none small-title">
          <b translate>QUANTITY</b>
        </div>
        <div class="col-8 d-flex col-md-12">
          <lib-buy-btn class="colmec-sales-buy-button" [id]="data.cartRow.productId"></lib-buy-btn>
        </div>
      </div>
    </div>

    <div class="col-6 col-md-2">
      <div class="row pt-1">
        <div class="col-4 d-flex d-md-none small-title">
          <b translate>PRICE</b>
        </div>
        <div class="col-8 col-md-12 text-md-center">
          <input
            type="number"
            class="form-control form-control-sm"
            [value]="orEmpty(data.cartRow.extra, 'orp.vb_pris')"
            [placeholder]="data.price.customerGrossPrice.value | number: '1.0-2'"
            (blur)="updateExtraField(data, $event.target.value, 'orp.vb_pris')"
          />
        </div>
      </div>
    </div>

    <div class="col-6 col-md-2">
      <div class="row pt-1">
        <div class="col-4 d-flex pl-2 d-md-none small-title">
          <b translate>NET_PRICE</b>
        </div>
        <div class="col-8 col-md-12 text-md-center">
          <lib-price
            [price]="data.price.cartRowUnitPriceInclRowDiscount.value"
            [currency]="data.price.cartRowUnitPriceInclRowDiscount.currencyCode"
          ></lib-price>
        </div>
      </div>
    </div>

    <div class="col-6 col-md-1">
      <div class="row pt-1">
        <div class="col-4 d-flex pl-2 d-md-none small-title">
          <b translate>DISCOUNT</b>
        </div>
        <div class="col-8 col-md-12 text-md-center">
          <input
            type="number"
            class="form-control form-control-sm d-none"
            [value]="orEmpty(data.cartRow.extra, 'orp.kundrabatt')"
            [placeholder]="data.price.backendPriceLevel.extra.CustomerDiscount"
            (change)="updateExtraField(data, $event.target.value, 'orp.kundrabatt')"
          />
          <input
            type="number"
            class="form-control form-control-sm"
            [value]="orEmpty(data.cartRow.extra, 'orp.rabatt1')"
            [placeholder]="data.price.backendPriceLevel.extra.Discount1"
            (change)="updateExtraField(data, $event.target.value, 'orp.rabatt1')"
          />
        </div>
      </div>
    </div>

    <div class="col-12 col-md-2">
      <div class="row pt-1">
        <div class="col-2 d-flex d-md-none pl-2 small-title">
          <b translate>TOTAL</b>
        </div>
        <div class="col-10 col-md-12 text-md-center price-cart-checkout">
          <lib-price
            [price]="data.price.cartRowTotalPriceInclRowDiscount.value"
            [currency]="data.price.cartRowTotalPriceInclRowDiscount.currencyCode"
          ></lib-price>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-3 pt-2">
      @if(data.availability.currentAvailability < data.cartRow.qty) {
        <div class="row pt-1 pl-3">
          <div class="col d-flex">
            <colmec-availability-warning> </colmec-availability-warning>
          </div>
        </div>
      }
    </div>
    <div class="col-12 col-md-2 pt-2">
      <div class="pl-3 pl-md-0 text-md-center">
        <i class="fas fa-box product-availability-box-icon"></i>&nbsp;
        <lib-availability [availability]="data.availability" *ngIf="data.availability"></lib-availability>
      </div>
    </div>
  </div>
</div>
